import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Competition, CupCompetition } from "@/modules/competitions/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Team } from "@/modules/team/entity";
export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const router = useRouter();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      const competition = await Competition.createQueryBuilder('competition').innerJoinAndSelect('competition.divisions', 'division').where('competition.id = :competitionId', {
        competitionId: route.params.id
      }).getOneOrFail();
      if (competition instanceof CupCompetition) {
        router.replace({
          name: 'competitions.cup',
          params: {
            id: competition.id
          },
          query: route.query
        });
        return;
      }
      const team = await Team.current();
      const divisionWithUser = collect(competition.divisions).first(d => d.teamIds.includes(team.id), competition.divisions[0]);
      router.replace({
        name: 'divisions.matches',
        params: {
          id: route.query.divisionId ?? divisionWithUser.id
        }
      });
    })), __temp = await __temp, __restore(), __temp);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      });
    };
  }
});